<template>
  <header class="page-header">
    <div class="header-container">
      <div class="header-left">
        <WelcomeText class="header-welcome" />
      </div>
      <HeaderProfile />
    </div>
  </header>
</template>

<script>
  import HeaderProfile from "@/components/navigation/header/HeaderProfile.vue";
  import WelcomeText from "@/components/navigation/header/WelcomeText.vue";

  export default {
    name: "Header",

    components: {
      HeaderProfile,
      WelcomeText,
    },
  };
</script>

<style lang="scss" scoped>
  .page-header {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 40;
    background: #ffffff;
    border-bottom: 1px solid #e2e8f0;

    @media screen and (min-width: 1280px) {
      left: 260px;
    }
  }

  .header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 32px;
    max-width: 100%;

    @media (max-width: 1279px) {
      padding-left: 72px; // Make room for hamburger menu
    }

    @media (max-width: 768px) {
      padding: 12px 16px;
      padding-left: 72px;
    }
  }

  .header-left {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .header-welcome {
    display: none;

    @media (min-width: 768px) {
      display: block;
    }
  }
</style>
